export interface Checklist {
    idChecklist: number;
    code: string;
    name: string;
    description: string;
    revisionNumber: number;
    revisionDate: string;
    state: number;
    idAdministration: number;
    questions: ChecklistQuestion[];
    answers: AnswerDto[];
    idChecklistSchedule: number;
    schedules: ChecklistScheduleDto[];
}

export interface Question {
    idChecklistQuestion: number;
    sequenceNo: number;
    description: string;
    hint: string | null;
    answerType: number;
    category: Category;
}

export interface Category {
  idChecklistQuestionCategory: number|null;
  name: string;
}

export interface AnswerDto {
    idQualityCheckAnswer: number;
    answerBoolean: boolean | null;
    answerNumber: number | null;
    answerText: string | null;
    description: string | null;
    remarks: string | null;
    photoFileData: string | null
    question: Question;
}

export interface ChecklistQuestion {
    idChecklistQuestion: number;
    sequenceNo: number;
    description: string;
    hint: string;
    answerType: number;
    idChecklist: string | null;
    category: ChecklistQuestionCategory
}

export interface ChecklistQuestionCategory {
  idChecklistQuestionCategory: number;
  name: string;
}

export interface ChecklistScheduleDto {
  idChecklistSchedule?: number;
  description?: string;
  type?: ScheduleType;
  startDate?: string;
  endDate?: string;
  onceDate?: string;
  dailyFrequency?: ScheduleDailyFrequencyDays;
  weeklyFrequency?: ScheduleWeeklyFrequencyDay;
  fourWeeklyFrequency?: ScheduleWeeklyFrequencyDay;
  monthlyFrequencyMonth?: ScheduleMonthlyFrequencyMonths;
  monthlyFrequencyDay?: ScheduleMonthlyFrequencyDays;
  monthlyFrequencyOn?: ScheduleMonthlyFrequencyOns;
  monthlyFrequencyOnDay?: ScheduleFrequencyDays;
  idChecklist?: number;
}

export enum ScheduleType {
  Inactive = 0,
  Once = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4,
  FourWeekly = 5,
}

export enum ScheduleDailyFrequencyDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 4,
  Thursday = 8,
  Friday = 16,
  Saturday = 32,
  Sunday = 64
}

export enum ScheduleWeeklyFrequencyDay {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6
}

export enum ScheduleMonthlyFrequencyMonths {
  January = 1,
  February = 2,
  March = 4,
  April = 8,
  May = 16,
  June = 32,
  July = 64,
  August = 128,
  September = 256,
  October = 512,
  November = 1024,
  December = 2048
}

export enum ScheduleMonthlyFrequencyDays {
  Day1 = 1,
  Day2 = 2,
  Day3 = 4,
  Day4 = 8,
  Day5 = 16,
  Day6 = 32,
  Day7 = 64,
  Day8 = 128,
  Day9 = 256,
  Day10 = 512,
  Day11 = 1024,
  Day12 = 2048,
  Day13 = 4096,
  Day14 = 8192,
  Day15 = 16384,
  Day16 = 32768,
  Day17 = 65536,
  Day18 = 131072,
  Day19 = 262144,
  Day20 = 524288,
  Day21 = 1048576,
  Day22 = 2097152,
  Day23 = 4194304,
  Day24 = 8388608,
  Day25 = 16777216,
  Day26 = 33554432,
  Day27 = 67108864,
  Day28 = 134217728,
  Day29 = 268435456,
  Day30 = 536870912,
  Day31 = 1073741824,
  Last = 2147483648
}

export enum ScheduleMonthlyFrequencyOns {
  First = 1,
  Second = 2,
  Third = 4,
  Fourth = 8,
  Last = 16
}

export enum ScheduleFrequencyDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 4,
  Thursday = 8,
  Friday = 16,
  Saturday = 32,
  Sunday = 64
}
